import { useRecoilState } from "recoil";
import { supportTicketsState } from "./atoms";
import { SupportTicket } from "../../../globals/interfaces";
import apiClient from "../../../apiClient";
import useSWR, { mutate } from "swr";
import { useEffect, useRef, useState } from "react";
import _ from "lodash";

const compareEmails = (a, b) => {
    if (!a || !b) {
        return false;
    }
    return a.toLowerCase() === b.toLowerCase();
}

export default function useSupportTickets(userEmail: string, endpoint?: string, userTickets?: boolean) {
    const [supportTickets, setSupportTickets] = useRecoilState(supportTicketsState);

    useEffect(() => {
        if (!endpoint) return;

        const getData = async () => {
            try {
                const res = await apiClient.get(endpoint);
                const { data } = res;
                data.sort((a, b) => {
                    const aMatches = compareEmails(a.assignedTo, userEmail);
                    const bMatches = compareEmails(b.assignedTo, userEmail);
                
                    if (aMatches && !bMatches) {
                        return -1; // a should come before b
                    }
                    if (!aMatches && bMatches) {
                        return 1; // b should come before a
                    }
                    return 0; // keep the original order
                });
                setSupportTickets(data);
            } catch (err) {
                alert(err);
            }
        }
        getData();

        let queryInterval;

        if (!userTickets) {
            queryInterval = setInterval(() => {
                getData();
            }, 5000);
        }

        return () => {
            clearInterval(queryInterval);
        }
    }, [endpoint, userTickets]);

    const updateData = (newTickets: Array<SupportTicket>) => {
        setSupportTickets(newTickets);
    }

    return {
        supportTickets,
        setSupportTickets,
        mutate,
        updateData
    }
}
